import { useQuery, cloneDeep } from '@graphcommerce/graphql'
import { useProductListParamsContext } from '@graphcommerce/magento-product/hooks/useProductListParamsContext'
import { StoreConfigDocument } from '@graphcommerce/magento-store'
import { i18n } from '@lingui/core'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useCallback } from 'react'
import { useProductListLinkReplace } from '../../../hooks/Product/useProductListLinkReplace'
import { Dropdown } from '../../Dropdown'

const perPages = [8, 12, 20]

export function ProductListPerPage() {
  const { params } = useProductListParamsContext()
  const replaceRoute = useProductListLinkReplace()
  const { data: storeConfigQuery } = useQuery(StoreConfigDocument)

  const defaultPerPage = perPages[0]
  const possibleOptionsFromConfig = storeConfigQuery?.storeConfig?.grid_per_page_values
    ?.toString()
    .split(',')
    .map((v) => Number(v))

  const possibleOptions = possibleOptionsFromConfig || perPages
  const perPage = params.pageSize || storeConfigQuery?.storeConfig?.grid_per_page || defaultPerPage

  const handlePerPageChange = useCallback(
    (option) => {
      const linkParams = cloneDeep(params)
      if (option?.value !== params.pageSize) linkParams.pageSize = option?.value
      delete linkParams.currentPage
      replaceRoute(linkParams)
    },
    [replaceRoute, params],
  )
  const handleChange = (event: SelectChangeEvent) => {
    if (handlePerPageChange) {
      handlePerPageChange(event.target)
    }
  }

  const options = possibleOptions?.map((p) => ({
    label: i18n._(/* i18n */ '{p} per page', { p }),
    value: p,
  }))

  return (
    <Select
      value={perPage.toString()}
      className='Type-Large-Regular md:mr-[10px]'
      defaultValue={perPage.toString()}
      onChange={handleChange}
      size='small'
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value || ''}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  )
}
